import http from "./httpService";

const apiEndpoint = "/api/status-report-filters";

export function getAll() {
    return http.get(apiEndpoint);
}

export function get(id) {
    return http.get(apiEndpoint + "/" + id);
}

export function create(filter) {
    return http.post(apiEndpoint, {
        name: filter.name,
        type: filter.type,
        data: filter.data
    });
}

export function update(id, filter) {
    return http.put(apiEndpoint + "/" + id, {
        name: filter.name,
        type: filter.type,
        data: filter.data
    });
}

export function remove(id) {
    return http.delete(apiEndpoint + "/" + id);
}

export function getActiveSections(id) {
    return http.get(apiEndpoint + "/" + id + "/active-sections");
}

export function addActiveSections(id, sections) {
    return http.post(apiEndpoint + "/" + id + "/active-sections", {
        sections: sections
    });
}

export function removeActiveSections(id, sections) {
    return http.delete(apiEndpoint + "/" + id + "/active-sections", {
        data: { sections: sections }
    });
}

export function replaceActiveSections(id, sections) {
    return http.put(apiEndpoint + "/" + id + "/active-sections", {
        sections: sections
    });
}

const statusReportFilterService = {
    getAll,
    get,
    create,
    update,
    remove,
    getActiveSections,
    addActiveSections,
    removeActiveSections,
    replaceActiveSections
};

export default statusReportFilterService;